import {useEffect,useRef,useState,useContext} from "react"
import FloatingContext from "../contexts/FloatingContext"
import useApi from "../hooks/useApi"
import useFloating from "../hooks/useFloating"
import ButtonAction from "../commons/ButtonAction"
import Datepicker from "../commons/Datepicker"
import Dropdown from "../commons/Dropdown"
import SwitchButton from "../commons/SwitchButton"
import close from "../assets/close-pink.svg"

export default function LiquidationsFilters(){

    const {manageFloating,floatingReady}=useFloating()
    const [floatingContext]=useContext(FloatingContext)
    const requestApi=useApi()
    const value=floatingContext.value
    const setValue=floatingContext.setValue

    const filter1=useRef()
    const filter2=useRef()
    const filter3=useRef()
    const filter4=useRef()
    const filter5=useRef()
    const filter6=useRef()
    const filter7=useRef()
    const filter8=useRef()
    const filter9=useRef()
    const filter10=useRef()
    const filter11=useRef()
    const [filter1Val,setFilter1Val]=useState("")
    const [filter2Val,setFilter2Val]=useState("")
    const [filter3Val,setFilter3Val]=useState("")
    const [filter4Val,setFilter4Val]=useState("")
    const [filter5Val,setFilter5Val]=useState("")
    const [filter6Val,setFilter6Val]=useState("")
    const [filter7Val,setFilter7Val]=useState([])
    const [filter8Val,setFilter8Val]=useState([])
    const [filter9Val,setFilter9Val]=useState([])
    const [filter10Val,setFilter10Val]=useState("")
    const [filter11Val,setFilter11Val]=useState([])

    const [bankOptions,setBankOptions]=useState([])

    const loadBanks=()=>{
        return new Promise(function(resolve){
            resolve(
                requestApi("liquidations/banks",{})
                    .then(data=>{
                        let newOptions=[]
                        data.items.forEach(function(bank){
                            newOptions.push({label:bank.name,value:bank.value})
                        })
                        return newOptions
                    })
            )
        })
    }

    useEffect(()=>{
        floatingReady(0)
        Promise.all([loadBanks].map(func=>func())).then((result)=>{
            setBankOptions(result[0])
            floatingReady(1)
        })
    },[])

    const apply=()=>{
        let filter8List=[]
        if(filter8.current.getValue()){
            filter8.current.getValue().forEach(function(item){
                filter8List.push(item["value"])
            })
        }
        let filter9List=[]
        if(filter9.current.getValue()){
            filter9.current.getValue().forEach(function(item){
                filter9List.push(item["value"])
            })
        }
        let filter11List=[]
        if(filter11.current.getValue()){
            filter11.current.getValue().forEach(function(item){
                filter11List.push(item["value"])
            })
        }
        setValue({
            period:filter1.current.getValue()[0]?filter1.current.getValue()[0].value:"",
            month:filter2.current.getValue()[0]?filter2.current.getValue()[0].value:"",
            year:filter3.current.getValue()[0]?filter3.current.getValue()[0].value:"",
            date:filter4Val,
            date_start:filter5Val,
            date_end:filter6Val,
            company:filter7Val,
            card:filter8List,
            bank:filter9List,
            operations:filter10Val,
            payment:filter11List
        })
        manageFloating("hide")
    }

    const clear=()=>{
        setFilter1Val("")
        setFilter2Val("")
        setFilter3Val("")
        setFilter4Val("")
        setFilter5Val("")
        setFilter6Val("")
        setFilter7Val([])
        setFilter8Val([])
        setFilter9Val([])
        setFilter10Val("")
        setFilter11Val([])
        filter1.current.setValue("")
        filter2.current.setValue("")
        filter3.current.setValue("")
        filter8.current.setValue("")
        filter9.current.setValue("")
        filter11.current.setValue("")
        setValue("")
        manageFloating("hide")
    }

    useEffect(()=>{
        if(filter1Val!="" && filter1Val!=undefined){
            restrict("period")
        }
    },[filter1Val])

    useEffect(()=>{
        if((filter2Val!="" && filter2Val!=undefined) || (filter3Val!="" && filter3Val!=undefined)){
            restrict("month_year")
        }
    },[filter2Val])

    useEffect(()=>{
        if((filter2Val!="" && filter2Val!=undefined) || (filter3Val!="" && filter3Val!=undefined)){
            restrict("month_year")
        }
    },[filter3Val])

    useEffect(()=>{
        if(filter4Val!=""){
            restrict("date")
        }
    },[filter4Val])

    useEffect(()=>{
        if(filter5Val!="" || filter6Val!=""){
            restrict("interval")
        }
    },[filter5Val])

    useEffect(()=>{
        if(filter5Val!="" || filter6Val!=""){
            restrict("interval")
        }
    },[filter6Val])

    const restrict=(filter)=>{
        if(filter=="period"){
            setFilter2Val("")
            filter2.current.setValue("")
            setFilter3Val("")
            filter3.current.setValue("")
            setFilter4Val("")
            setFilter5Val("")
            setFilter6Val("")
        }else if(filter=="month_year"){
            setFilter1Val("")
            filter1.current.setValue("")
            setFilter4Val("")
            setFilter5Val("")
            setFilter6Val("")
        }else if(filter=="date"){
            setFilter1Val("")
            filter1.current.setValue("")
            setFilter2Val("")
            filter2.current.setValue("")
            setFilter3Val("")
            filter3.current.setValue("")
            setFilter5Val("")
            setFilter6Val("")
        }else if(filter=="interval"){
            setFilter1Val("")
            filter1.current.setValue("")
            setFilter2Val("")
            filter2.current.setValue("")
            setFilter3Val("")
            filter3.current.setValue("")
            setFilter4Val("")
        }
    }
    useEffect(()=>{
        if(value!="" && filter1.current && filter2.current && filter3.current){
            if(value["period"]!=""){
                filter1.current.props["options"].forEach(function(item){
                    if(value["period"]==item.value){
                        filter1.current.setValue({label:item.label,value:item.value})
                    }
                })
            }
            if(value["month"]!=""){
                filter2.current.props["options"].forEach(function(item){
                    if(value["month"]==item.value){
                        filter2.current.setValue({label:item.label,value:item.value})
                    }
                })
            }
            if(value["year"]!=""){
                filter3.current.props["options"].forEach(function(item){
                    if(value["year"]==item.value){
                        filter3.current.setValue({label:item.label,value:item.value})
                    }
                })
            }
            if(value["date"]!=""){
                setFilter4Val(value["date"])
            }
            if(value["date_start"]!=""){
                setFilter5Val(value["date_start"])
            }
            if(value["date_end"]!=""){
                setFilter6Val(value["date_end"])
            }
            if(value["company"] && value["company"].length>0){
                setFilter7Val(value["company"])
            }
            if(value["card"] && value["card"].length>0 && filter8.current){
                let newValue=[];
                filter8.current.props["options"].forEach(function(item){
                    if(value["card"].includes(item.value)){
                        newValue.push({label:item.label,value:item.value})
                    }
                })
                filter8.current.setValue(newValue)
            }
            if(value["operations"] && value["operations"].length>0){
                setFilter10Val(value["operations"])
            }
            if(value["payment"] && value["payment"].length>0 && filter11.current){
                let newValue=[];
                const paymentOptions = [
                    {label:"Debin",value:"53"},
                    {label:"QR",value:"61"}
                ];
                paymentOptions.forEach(function(item){
                    if(value["payment"].includes(item.value)){
                        newValue.push({label:item.label,value:item.value})
                    }
                })
                filter11.current.setValue(newValue)
            }
        }
    },[value])

    useEffect(()=>{
        if(value && filter9.current && value["bank"]){
            if(value["bank"].length>0){
                let newValue=[];
                filter9.current.props["options"].forEach(function(item){
                    if(value["bank"].includes(item.value)){
                        newValue.push({label:item.label,value:item.value})
                    }
                })
                filter9.current.setValue(newValue)
            }
        }
    },[bankOptions])

    return(
        <div className="floating-blocks">
            <div className="floating-close-frame">
                <div className="floating-close" onClick={()=>{manageFloating("hide")}}><img src={close} /></div>
            </div>
            <div className="floating-content">
                <div className="floating-group">Fechas</div>
                <div className="floating-options">
                    <div className="floating-full">
                        <Dropdown ref={filter1} val={filter1Val} setVal={setFilter1Val} placeholder="Período" multiple={0} searchable={0} options={[
                            {label:"Indiferente",value:""},
                            {label:"Última hora",value:"last_hour"},
                            {label:"Hoy",value:"today"},
                            {label:"Ayer",value:"yesterday"},
                            {label:"Última semana",value:"last_week"},
                            {label:"Últimos quince días",value:"last_15_days"},
                            {label:"Este mes",value:"this_month"},
                            {label:"Últimos tres meses",value:"last_three_months"},
                            {label:"Últimos seis meses",value:"last_six_months"},
                            {label:"Este año",value:"this_year"}
                        ]} />
                    </div>
                    <div className="floating-half" >
                        <Dropdown ref={filter2} val={filter2Val} setVal={setFilter2Val} placeholder="Mes" multiple={0} searchable={0} options={[
                            {label:"Todos",value:""},
                            {label:"Enero",value:"01"},
                            {label:"Febrero",value:"02"},
                            {label:"Marzo",value:"03"},
                            {label:"Abril",value:"04"},
                            {label:"Mayo",value:"05"},
                            {label:"Junio",value:"06"},
                            {label:"Julio",value:"07"},
                            {label:"Agosto",value:"08"},
                            {label:"Septiembre",value:"09"},
                            {label:"Octubre",value:"10"},
                            {label:"Noviembre",value:"11"},
                            {label:"Diciembre",value:"12"}
                        ]} />
                        <Dropdown ref={filter3} val={filter3Val} setVal={setFilter3Val} placeholder="Año" multiple={0} searchable={0} options={[
                            {label:"Todos",value:""},
                            {label:"2022",value:"2022"},
                            {label:"2023",value:"2023"},
                            {label:"2024",value:"2024"},
                            {label:"2025",value:"2025"},
                            {label:"2026",value:"2026"},
                            {label:"2027",value:"2027"},
                            {label:"2028",value:"2028"},
                            {label:"2029",value:"2029"},
                            {label:"2030",value:"2030"},
                            {label:"2031",value:"2031"},
                            {label:"2032",value:"2032"},
                            {label:"2033",value:"2033"},
                            {label:"2034",value:"2034"},
                            {label:"2034",value:"2034"}
                        ]} />
                    </div>
                    <div className="floating-full">
                        <Datepicker ref={filter4} val={filter4Val} setVal={setFilter4Val} label="Fecha" />
                    </div>
                </div>
                <div className="floating-group">Intervalo</div>
                <div className="floating-options">
                    <div className="floating-half" >
                        <Datepicker ref={filter5} val={filter5Val} setVal={setFilter5Val} label="Desde" />
                        <Datepicker ref={filter6} val={filter6Val} setVal={setFilter6Val} label="Hasta" />
                    </div>
                </div>
                <div className="floating-group">Procesador</div>
                <div className="floating-options">
                    <div className="floating-half">
                        <SwitchButton ref={filter7} val={filter7Val} setVal={setFilter7Val} multiple={true}
                            options={[
                                {label:"Prisma",value:"prisma"},
                                {label:"Fiserv",value:"fiserv"},
                                {label:"Amex Global",value:"amex_global"},
                                {label:"Cabal",value:"cabal"},
                                {label:"Naranja",value:"naranja"},
                                {label:"BPN Confiable",value:"bpn_confiable"}
                        ]} />
                    </div>
                </div>
                <div className="floating-group">Tarjeta/banco</div>
                <div className="floating-options">
                    <div className="floating-full">
                        <Dropdown ref={filter8} val={filter8Val} setVal={setFilter8Val} placeholder="Tarjeta" multiple={1} searchable={0} options={[
                            {label:"Visa",value:"visa"},
                            {label:"Visa Débito",value:"visa_debit"},
                            {label:"Mastercard",value:"mastercard"},
                            {label:"Mastercard Débito",value:"mastercard_debit"},
                            {label:"Maestro",value:"maestro"},
                            {label:"American Express",value:"amex"},
                            {label:"Cabal",value:"cabal"},
                            {label:"Naranja X",value:"naranjax"},
                            {label:"Diners",value:"diners"}
                        ]} />
                        <Dropdown ref={filter9} val={filter9Val} setVal={setFilter9Val} placeholder="Banco" multiple={1} searchable={0} options={bankOptions} />
                    </div>
                </div>
                <div className="floating-group">Cantidad de operaciones</div>
                <div className="floating-options">
                    <div className="floating-half">
                        <SwitchButton ref={filter10} val={filter10Val} setVal={setFilter10Val}
                            options={[
                                {label:"Ninguna",value:"none"},
                                {label:"Sólo una",value:"one"},
                                {label:"Entre 10~50",value:"10_50"},
                                {label:"Entre 50~100",value:"50_100"},
                                {label:"Más de 100",value:"100"},
                                {label:"Más de 500",value:"500"}
                        ]} />
                    </div>
                </div>
                <div className="floating-group">Medio de pago</div>
                <div className="floating-options">
                    <div className="floating-full">
                        <Dropdown ref={filter11} val={filter11Val} setVal={setFilter11Val} placeholder="Medio de pago" multiple={1} searchable={0} options={[
                            {label:"Debin",value:"53"},
                            {label:"QR",value:"61"}
                        ]} />
                    </div>
                </div>
            </div>
            <div className="floating-actions">
                <ButtonAction label="Resetear" color="pink" clickEvent={clear} />
                <ButtonAction label="Aplicar" color="purple" clickEvent={apply} />
            </div>
        </div>
    )
    
}